module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "gray-back"
  }, [_c('div', {
    staticClass: "mine-box-title"
  }, [_vm._v(_vm._s(_vm.$T('我的订单')))]), _vm._v(" "), _c('div', {
    staticClass: "mine-content"
  }, [_c('el-tabs', {
    on: {
      "tab-click": _vm.onStatusChange
    },
    model: {
      value: (_vm.active),
      callback: function($$v) {
        _vm.active = $$v
      },
      expression: "active"
    }
  }, [_c('el-tab-pane', {
    attrs: {
      "label": _vm.$T('全部'),
      "name": "0"
    }
  }), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": _vm.$T('待付款'),
      "name": "1"
    }
  }), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": _vm.$T('待发货'),
      "name": "3"
    }
  }), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": _vm.$T('待收货'),
      "name": "4"
    }
  })], 1), _vm._v(" "), (_vm.loading) ? _c('div', {
    staticClass: "bc-order-empty"
  }, [_vm._v(_vm._s(_vm.$T('观众中心加载中')))]) : (!_vm.list.length) ? _c('div', {
    staticClass: "bc-order-empty"
  }, [_vm._v(_vm._s(_vm.$T('暂无订单')))]) : _c('el-table', {
    attrs: {
      "data": _vm.list,
      "show-header": false
    }
  }, [_c('el-table-column', {
    attrs: {
      "min-width": "220"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', {
          staticClass: "bc-order-row"
        }, [_c('img', {
          staticClass: "bc-order-pic",
          attrs: {
            "src": _vm.firstItemPic(scope.row),
            "alt": ""
          }
        }), _vm._v(" "), _c('div', [_c('div', {
          staticClass: "bc-order-title"
        }, [_vm._v(_vm._s(scope.row.title))]), _vm._v(" "), _c('div', {
          staticClass: "gray-light"
        }, [_vm._v("\n                " + _vm._s(_vm.$T('订单号')) + " " + _vm._s(scope.row.code || scope.row.id) + "\n              ")]), _vm._v(" "), _c('div', {
          staticClass: "gray-light goods-num"
        }, [_vm._v("\n                " + _vm._s(_vm.itemCountText(scope.row)) + "\n              ")])])])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "width": "120"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', {
          staticClass: "table-goods-price"
        }, [_vm._v("\n            " + _vm._s(_vm.money(scope.row.pay_price)) + "\n          ")])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "width": "140"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', [_vm._v(_vm._s(_vm.formatTime(scope.row)))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "width": "120"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-tag', {
          attrs: {
            "size": "small",
            "type": _vm.statusTagType(scope.row)
          }
        }, [_vm._v("\n            " + _vm._s(_vm.statusName(scope.row)) + "\n          ")])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "right",
      "min-width": "200"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._l((_vm.actionButtons(scope.row)), function(btn, bi) {
          return _c('el-button', {
            key: 'b' + bi,
            attrs: {
              "size": "medium",
              "type": btn.class === 'primary' ? 'primary' : 'default'
            },
            on: {
              "click": function($event) {
                return _vm.onAction(scope.row, btn)
              }
            }
          }, [_vm._v("\n            " + _vm._s(_vm.btnLabel(btn)) + "\n          ")])
        }), _vm._v(" "), _c('el-button', {
          attrs: {
            "size": "medium",
            "type": "primary"
          },
          on: {
            "click": function($event) {
              return _vm.goDetail(scope.row)
            }
          }
        }, [_vm._v("\n            " + _vm._s(_vm.$T('订单详情')) + "\n          ")])]
      }
    }])
  })], 1), _vm._v(" "), (_vm.total > 0) ? _c('div', {
    staticClass: "table-pagination"
  }, [_c('el-pagination', {
    attrs: {
      "background": "",
      "layout": "total, prev, pager, next",
      "current-page": _vm.page,
      "page-size": _vm.pageSize,
      "total": _vm.total
    },
    on: {
      "current-change": _vm.handleCurrentChange
    }
  })], 1) : _vm._e()], 1), _vm._v(" "), _c('SpectatorOfflinePayDialog', {
    attrs: {
      "show": _vm.payDialogShow,
      "ids": _vm.payOrderIds,
      "pay-price": _vm.payOrderPrice
    },
    on: {
      "onPaid": _vm.onOfflinePaid,
      "onClose": function($event) {
        _vm.payDialogShow = false
      }
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e49e93d2","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/mainindex/SpectatorOrderList.vue
// module id = 1606
// module chunks = 0